
		import Async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function (require) {
				cb( require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js") );
			}, "route-EmptyBg");
		}

		export default Async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/EmptyBg/index.js
// module id = Vjv/
// module chunks = 16